<template>
  <v-container
    fluid
    fill-height
  >
    <v-layout
      align-center
      justify-center
      fill-height
    >
      <div class="not-found d-flex column justify-center align-center">
        <div class="code-404 grey lighten-3 mr-4 text-xs-center">
          <div class="display-4 grey--text text--lighten-1">
            404
          </div>
          <div class="body-2 grey--text text--darken-1">
            Page Not Found
          </div>
        </div>
        <div class="ml-4">
          <div class="display-3 primary--text ma-2">
            Oops!
          </div>
          <div class="subheading grey--text text--darken-1 ma-2">
            PAGE NOT FOUND ON THE SERVER
          </div>
          <v-btn
            class="ma-2"
            color="primary"
            @click="navigateHome"
          >
            Go to Home
          </v-btn>
        </div>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'NotFoundComponent',
  methods: {
    navigateHome() {
      this.$router.push(`/${this.$store.state.profile.role}`);
    }
  }
};
</script>

<style scoped>
.not-found {
  height: 540px;
}
.code-404 div:first-child {
  font-weight: 500;
}
</style>
